// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__1KAsc","inputWrap":"CustomTip_inputWrap__3jLG4"};